<template>
  <div>
    <footer>
      <div class="container">
        <div class="row justify-content-center">
          <ul class="text-small list-group list-group-horizontal">
            <li class="list-group-item">
              <a class="text-muted text-small" href="https://heurix.io/#about">About</a>
            </li>
            <li class="list-group-item">
              <a class="text-muted" href="https://heurix.io/privacy-policy/">Privacy</a>
            </li>
            <li class="list-group-item">
              <a class="text-muted" href="https://heurix.io/terms-and-conditions/">Terms</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    export default {
        name: 'NavigationFooter'
    }
</script>

<style lang="scss" scoped>
    footer {
        padding: 5em 0 3em;
        font-size: .8em;

        .list-group-item {
            border: None;
        }

        &.sticky {
            position: absolute;
            bottom: 1em;
            left: 0;
            width: 100%;
            margin: 0;
            padding: 0;
        }
    }
</style>
